// extracted by mini-css-extract-plugin
export default {"link":"dC-z","disabled":"eC-z"};